var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert",class:_vm.messageClass,attrs:{"role":"alert"}},[_c('span',{staticClass:"glyphicon glyphicon-remove-sign"}),_vm._v(" "+_vm._s(_vm.message))])}
var staticRenderFns = []

export { render, staticRenderFns }